var _style, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#21272F;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3,12.6c0-0.6,0.5-1.2,1.1-1.2h15.8c0.6,0,1.1,0.5,1.1,1.2s-0.5,1.2-1.1,1.2H4.1C3.5,13.7,3,13.2,3,12.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3,6.7c0-0.6,0.5-1.2,1.1-1.2h15.8c0.6,0,1.1,0.5,1.1,1.2c0,0.6-0.5,1.2-1.1,1.2H4.1C3.5,7.9,3,7.4,3,6.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3,18.4c0-0.6,0.5-1.2,1.1-1.2h15.8c0.6,0,1.1,0.5,1.1,1.2c0,0.6-0.5,1.2-1.1,1.2H4.1C3.5,19.6,3,19,3,18.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/Menu.4d6c016d60266422e44ad8fc6ea7ae4a.svg";
export { ForwardRef as ReactComponent };